import {AfterViewInit, Directive, ElementRef, Input, OnDestroy} from '@angular/core';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {GtQueueService} from '@app/services/gt-queue.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Directive({
  selector: '[gtDisableWhenNotloggedin]'
})
export class DisableWhenNotLoggedInDirective implements AfterViewInit, OnDestroy {
  @Input() disabled: false;
  private destroyed = new Subject<void>();

  constructor(
    private elementRef: ElementRef,
    private queueService: GtQueueService,
    private authenticationService: GtAuthenticationService
  ) {}

  ngAfterViewInit() {
    this.queueService
      .getAgentState(this.authenticationService.oname, this.authenticationService.login)
      .pipe(takeUntil(this.destroyed))
      .subscribe(loggedIn => {
        if (!this.disabled) {
          this.elementRef.nativeElement.disabled = !loggedIn;
        } else {
          this.elementRef.nativeElement.disabled = true;
        }
      });
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
